export default "__VITE_ASSET__B$att0ua__"